import { BreadcrumbsWithSeo } from '@/components/shared/BreadcrumbsWithSeo';
import { useMarketplaceChain } from '@/hooks/use-marketplace-chain';
import { routes } from '@/utils/routes';
import { Box, Container, Heading, Text } from '@chakra-ui/react';
import { LogoCompactIcon } from '@sphere/icons';
import useTranslation from 'next-translate/useTranslation';
import { rem } from 'polished';

export const SupportHeader = () => {
  const { t } = useTranslation('support');
  const marketplaceChain = useMarketplaceChain();

  return (
    <Box
      bg="primary"
      color="darkPurple"
      py={{ base: 'space.24', lg: 'space.80' }}
      overflow="hidden"
    >
      <Container pos="relative" pt="space.12" pb="space.20" variant="breakout">
        <BreadcrumbsWithSeo
          color="darkPurple"
          activeColor="#4D136680"
          pages={[
            {
              name: t('common:crumbs.home'),
              href: routes.home(marketplaceChain.routePrefix),
            },
            {
              name: t('title'),
              href: routes.support,
            },
          ]}
          textStyles={{ fontWeight: 'medium' }}
          mb={{ base: 'space.32', lg: 'space.48' }}
        />
        <Heading
          as="h1"
          fontSize={{ base: '2xl', lg: '6xl' }}
          fontWeight="bold"
          mb={{ base: 'space.16', lg: 'space.32' }}
        >
          {t('title')}
        </Heading>
        <Text
          fontSize={{ base: 'md', lg: '2xl' }}
          fontWeight="medium"
          lineHeight="xs"
          maxW={rem(480)}
        >
          {t('description')}
        </Text>
        <LogoCompactIcon
          display={{ base: 'none', lg: 'block' }}
          pos="absolute"
          right={{ base: rem(-120), xl: rem(-100) }}
          top={{ base: rem(-170), xl: rem(-236) }}
          fill="blackBg"
          boxSize={{ base: rem(600), xl: rem(745) }}
          transform="rotate(-60deg)"
        />
      </Container>
    </Box>
  );
};
